import "../styles/Faq.css";
import * as React from "react";
import {Config} from "../Config";
import {Badge} from "./Badge";
import {Button, ButtonIcon, ButtonType} from "./Button";

export function Faq() {
    const accordions = [
        {
            head: "How long does a typical project take?",
            body: <div>
                <div>
                    Timelines vary based on scope, but a single landing page usually takes 1–2 weeks from kickoff to launch. We’ll give you a clear timeline after our first call.
                </div>
            </div>
        },
        {
            head: "Can you work with our existing brand or design system?",
            body: <div>
                <div>
                    Absolutely. Whether you have a full brand guide or just a logo and color palette, we adapt our process to fit your brand. If needed, we can help refine or expand your visual identity for the web.
                </div>
            </div>
        },
        {
            head: "What if we don’t have a logo or visual identity yet?",
            body: <div>
                <div>
                    No worries, while we don’t offer full brand identity packages (like logo design and manuals), we define a strong visual direction for your site, including colors, typography, and layout. Enough to make your brand look sharp online.
                </div>
            </div>
        },
        {
            head: "Do you only work with Framer?",
            body: <div>
                <div>Framer is our go-to no-code tool because it’s fast, flexible, and great for modern web design. But if you prefer a custom-coded site, that’s also something we specialize in. If you choose this option, we will handle all the implementation ourselves.</div>
            </div>
        },
        {
            head: "I want to buy your Framer template. Will you customize it for me?",
            body: <div>
                <div className={"margin"}>
                    Yes! If you go for our highest-tier template option, which includes full-service support, we’ll handle all the customizations for you. Your Framer site gets tailored exactly to your needs — no extra effort needed.
                </div>
                <div>
                    With the other pricing tiers, you still get a powerful, customizable template that you can easily adjust yourself using Framer’s intuitive tools.
                </div>
            </div>
        },
        {
            head: "Do you work with other design agencies? I would like to hire you.",
            body: <div>
                <div>Yes! Our services are designed to fit the needs of startups, individual creatives looking to enhance their brand visuals as well as creative agencies in need of another pair of hands for design or both design and development.   To discuss how we can assist with your projects, book a call for any of the packages listed above.</div>
            </div>
        },
        {
            head: "Is there any design or development work that you don’t cover?",
            body: <div>
                <div className={"margin"}>
                    Right now, we focus on what we do best — visual web design, no-code builds in Framer and custom-coded solutions. That’s what you’ll find in our core packages.
                </div>
                <div>
                    That said, we also have experience in product design, social media design, and visual design beyond the web. If you need something outside our current focus, feel free to ask. If we have the capacity and it’s a good fit, we’re open to collaboration.
                </div>
            </div>
        },
        {
            head: "Can I pause my existing subscription?",
            body: <div>
                <div className={"margin"}>
                    Yes, absolutely. Life happens, we understand that. If something comes up and you need to pause, just let us know. We’ll freeze your existing subscription right where it is and pick things back up when you’re ready. No progress lost.
                </div>
                <div>
                    Billing runs in 30-day cycles, so if you’ve used, say, 15 days, you’ll still have 15 days left to use later. It’s a flexible setup for when you don’t have a full month of work.
                </div>
            </div>
        }
    ];
    const [opened, setOpened] = React.useState([]);

    function toggleOpened(index) {
        let newOpened = opened.slice(0);
        if(opened.includes(index)) {
            newOpened.splice(opened.indexOf(index), 1);
        } else {
            newOpened.push(index);
        }
        setOpened(newOpened)
    }

    return <div className="faq section" id={Config.PageSections.FAQ}>
        <div className="column column-1">
            <Badge className={"animate-from-bottom"}>FAQ</Badge>
            <h2 className={"animate-from-bottom delay-1"}>
                Still got questions? <br /> We’ve got answers.
            </h2>
            <p className={"animate-from-bottom delay-2"}>We’ve answered the most common “What ifs” so you don’t have to wonder.</p>
            <div className={"card animate-from-bottom delay-2"}>
                <div>
                    <div className={"person maria"}>
                        <img src={process.env.PUBLIC_URL + "/assets/maria.png"} alt={"najsu - Maria"}/>
                        <div className="name">Maria</div>
                    </div>
                    <div className={"person michal"}>
                        <img src={process.env.PUBLIC_URL + "/assets/michal.png"} alt={"najsu - Michal"}/>
                        <div className="name">Michal</div>
                    </div>
                    <div className="message-arrow">
                        <div className="message">
                            Let’s turn your vision<br />
                            into reality TOGETHER!
                        </div>
                        <div className="arrow"></div>
                    </div>
                </div>
                <p>Didn’t find the answer? We don’t bite. <br/>Ask us anything. 👇🏻</p>
                <Button classes={["btn-light", "btn-md"]} type={ButtonType.Link} onClick={"mailto:" + Config.Email} icon={ButtonIcon.Mail} secondContentChildren={Config.Email}>Email Us</Button>
            </div>
        </div>
        <div className="column column-2 animate-from-bottom delay-3">
            {
                accordions.map((accordion, index) => {
                    return <div className={"accordion" + (opened.includes(index) ? " opened" : "")} key={"accordion_" + index}
                                onClick={e => toggleOpened(index)}
                    >
                        {IconPlus}
                        {IconMinus}
                        <div className="accordion-header font-body-M-Regular">{accordion.head}</div>
                        <div className="accordion-content font-body-M-Regular">{accordion.body}</div>
                    </div>
                })
            }
        </div>
    </div>;
}

const IconPlus = <svg className={"icon-plus"} width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12.7852" r="11.5" stroke="currentColor"/>
    <path d="M8 12.7852H16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 16.7852V8.78516" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

const IconMinus = <svg className={"icon-minus"} width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 8.78516H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.9998 8.78516H3.99976" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>


